import { render, staticRenderFns } from "./charge-open-banking-wallet-manually.vue?vue&type=template&id=653350ca&scoped=true"
import script from "./charge-open-banking-wallet-manually.vue?vue&type=script&lang=js"
export * from "./charge-open-banking-wallet-manually.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653350ca",
  null
  
)

export default component.exports